export default __webpack_public_path__ + "static/Digital_HP_Unbranded_Patient_Tearsheet-fbc61276d73f6b192cb1f90c0f7e9f32.pdf";